<script setup>
import { useDropdown } from '@/composables/use-dropdown';
import SportLiveTvDropdownTransition from '@/sport-live-tv/components/sport-live-tv-dropdown-transition.vue';
import SportLiveTvDropdownTrigger from '@/sport-live-tv/components/sport-live-tv-dropdown-trigger.vue';
import SportLiveTvFilterPanel from '@/sport-live-tv/components/sport-live-tv-filter-panel.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  categories: { type: Array, required: true },
  teams: { type: Array, required: true },
  selection: { type: Object, required: true },
});

const emit = defineEmits(['clear', 'apply']);

const { t } = useSportLiveTvTranslation();
const { isOpen, dropdownRef, close, toggle } = useDropdown();

const applyAndClose = (draft) => {
  emit('apply', draft);
  close();
};
</script>

<template>
  <div ref="dropdownRef" class="sport-live-tv-filter-dropdown">
    <SportLiveTvDropdownTrigger :label="t('filterAndSort')" :open="isOpen" @click="toggle" />
    <SportLiveTvDropdownTransition>
      <SportLiveTvFilterPanel v-if="isOpen" :categories="categories" :teams="teams" :selection="selection" @clear="emit('clear')" @apply="applyAndClose" />
    </SportLiveTvDropdownTransition>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-dropdown {
  position: relative;

  @include mobile-sm-max {
    width: 100%;
  }
}
</style>
